import React, { useContext } from "react";
import { useDispatch } from "react-redux";

import { PopupContext } from "@app/dev/contexts/popup";
import { useTranslation } from "@common/hooks/translation";

import { RegisterMode, ClearCardRegistered } from "../../../../dev/actions/terminal";

import './style.scss';

const DmsSuccess = ({ body, title }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);

  const registerPopupForDms = () => {
    closePopup();
    dispatch(RegisterMode(false));
    dispatch(ClearCardRegistered());
  }

  return (
    <div className="dms-success-popup">
      <div className="title-popup-page-m-dms">
        {title && <p className='auth-popup-title'>{t(title)}</p>}
        <button className="popup-closed-b" onClick={registerPopupForDms} />
      </div>
      <div className="ticket-results-view-p">
        <p>{t(body)}</p>
        <i className="success-pu" />
        <div className="buttons-view-w-t">
          <div className="separator-box-buttons-m-wrap">
            <div className="separator-box-buttons-m auth-full-width-button">
              <button className="button-view-normal-m trans-m" onClick={registerPopupForDms}>
                {t("Done")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DmsSuccess;
